import { Environment } from '../env';

export const ENV: Environment = window.__PSN_ENV__;
